import { render, staticRenderFns } from "./AddProductPage.vue?vue&type=template&id=3ca23d7e&scoped=true"
import script from "./AddProductPage.vue?vue&type=script&lang=js"
export * from "./AddProductPage.vue?vue&type=script&lang=js"
import style0 from "./AddProductPage.vue?vue&type=style&index=0&id=3ca23d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca23d7e",
  null
  
)

export default component.exports